import { groupBy } from "lodash";
import { BasePortfolio } from "~/normalizr/PortfoliosSchema";
import { FieldTypes } from "../types";

export const root = "root";
export const getFieldsByParent = (fields: Field[]) => groupBy(fields, f => f.Condition?.FieldId || root);

const portfolioFieldName = "Please select your portfolio:";

const getWidgetNameByItemType = (itemType: FieldTypes) => {
    switch (itemType) {
        case FieldTypes.Input:
            return "single_line_record_input_field";
        case FieldTypes.CheckboxList:
            return "checkbox_list_record_input_field";
        case FieldTypes.Dropdown:
            return "dropdown_record_field";
        case FieldTypes.Separator:
            return "separator_record_field";
        case FieldTypes.RadioButtonList:
            return "radiobutton_list_record_input_field";
        case FieldTypes.Paragraph:
            return "paragraph_record_field";
        case FieldTypes.Header:
            return "header_record_field";
        case FieldTypes.TextArea:
            return "textarea_record_input_field";
        case FieldTypes.Date:
            return "date_record_input_field";
        case FieldTypes.FileAttach:
            return "file-attach_record_input_field";
    }
};

export type Field = {
    Required: boolean;
    Label: string;
    Type: FieldTypes;
    Deleted: boolean;
    FieldID: string;
    DeletedOptions?: string[];
    Options?: { Id: number; Name: string }[];
    Values?: string[];
    Condition?: { FieldId: string; OptionId: number };
};

type WidgetOptions = {
    model: Field & { Remove?: boolean };
    resources: any;
    attachments: any;
    culture: any;
    ui: any;
    mode: "New" | "Edit" | "Preview";
    fields: Record</* FieldID */ string, Field[]>;
    portfolios: BasePortfolio[];
};

export const renderFieldWidget = (container: JQuery<HTMLElement>, options: WidgetOptions) => {
    let widgetName = getWidgetNameByItemType(options.model.Type);

    if (
        !options.model.Deleted &&
        options.model.Type === FieldTypes.Dropdown &&
        options.model.Label === portfolioFieldName &&
        !!options.portfolios
    ) {
        widgetName = "portfolio_dropdown_record_field";
    }

    // Add new element
    let newElement = $('<li class="frm-rcrd-li"></li>');
    newElement.attr("widgetName", widgetName);
    container.append(newElement);

    // Create widget
    let widgetFunction = (newElement as any)[widgetName];
    let { model, resources, attachments, culture, ui, mode, fields, portfolios } = options;
    widgetFunction.call(newElement, { model, resources, attachments, culture, ui, mode, fields, portfolios });

    return newElement;
};

export const runWidgetFunction =
    (methodName: string, ...args: any[]) =>
    (widget: JQuery<HTMLElement>) => {
        const widgetName = widget.attr("widgetName");
        if (widget.is(":ep-" + widgetName)) {
            const widgetFunction = (widget as any)[widgetName];
            return widgetFunction.call(widget, methodName, ...args);
        }
    };
